import React from 'react';
import { Grid } from '@mui/material';

import { BooleanField, ModuleSearchField, SelectField, SimpleTextField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function MailsDetailsSectionInfo(
	props: DetailsSectionInfoContentProps & { disableIdentityAssociation?: boolean }
) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* EMAIL ADDRESS */}
				<SimpleTextField
					name="mail_title"
					label={t('DETAILS_MAILS_FIELD_TITLE')}
					value={props.model.mail_title}
					isEdit
					sendChange={props.sendChange}
					required
					validations={{ isEmail: true }}
					validationErrors={{
						isDefaultRequiredValue: t('ERROR_TEXT_REQUIRED'),
						isEmail: t('ERROR_TEXT_EMAIL')
					}}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* DESCRIPTION */}
				<SimpleTextField
					name="mail_description"
					label={t('DETAILS_MAILS_FIELD_DESCRIPTION')}
					value={props.model.mail_description}
					isEdit
					sendChange={props.sendChange}
				/>
			</Grid>
			{!props.disableIdentityAssociation && (
				<>
					<Grid size={{ sm: 4, xs: 12 }}>
						{/* MAIL SOURCE TABLE */}
						<SelectField
							name="mail_table"
							label={t('CONTACTS_LINKED_TABLE')}
							options={[
								{ value: 'companies', title: t('MODULE_COMPANIES_NAME') },
								{ value: 'people', title: t('MODULE_PEOPLE_NAME') },
								{ value: 'users', title: t('MODULE_USERS_NAME') }
							]}
							value={props.model.mail_table}
							isEdit
							sendChange={props.sendChange}
						/>
					</Grid>
					<Grid size={{ sm: 8, xs: 12 }}>
						{/* MAIL ASSOCIATED ITEM */}
						{props.model.mail_table && (
							<ModuleSearchField
								name="mail_table_uid"
								label={props.model.mail_table ? t(`MODULE_${props.model.mail_table}_NAME`) : ''}
								module={props.model.mail_table}
								uid={props.model.mail_table_uid}
								isEdit
								sendChange={props.sendChange}
								required
								validationError={t('ERROR_TEXT_REQUIRED')}
							/>
						)}
					</Grid>
				</>
			)}
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* DEFAULT */}
				<BooleanField
					name="mail_default"
					label={t('DETAILS_MAILS_FIELD_DEFAULT')}
					value={props.model.mail_default}
					isEdit
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* DEMS ENABLED */}
				<BooleanField
					name="mail_dems_enabled"
					label={t('DETAILS_MAILS_FIELD_DEMS_ENABLED')}
					value={props.model.mail_dems_enabled}
					isEdit
					sendChange={props.sendChange}
				/>
			</Grid>
		</>
	);
}
